export enum ApplicationLanguages {
  Ar = 'ar',
  En = 'en',
}
